import React from 'react';

interface WaitingModalProps {
  isOpen: boolean;
  title: string;
  message?: string;
  gifUrl?: string;
  videoSrc?: string;
}

export const WaitingModal: React.FC<WaitingModalProps> = ({
  isOpen,
  title,
  message,
  gifUrl = "https://media.socialness.ai/loading/Pikachu+-+Waiting.gif",
  videoSrc
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-4 sm:p-8 mx-4 sm:mx-0 max-w-md w-full text-center">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2 sm:mb-4">
          {title}
        </h2>
        <div className="loading">
          {videoSrc ? (
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              className="w-full h-auto rounded-lg"
              style={{ maxHeight: '280px', minHeight: '200px' }}
            >
              <source src={videoSrc} type="video/mp4" />
              {gifUrl && (
                <img 
                  src={gifUrl} 
                  alt="Loading..." 
                  className="w-full h-auto rounded-lg"
                  style={{ maxHeight: '280px', minHeight: '200px' }}
                />
              )}
            </video>
          ) : (
            <img 
              src={gifUrl} 
              alt="Loading..." 
              className="w-full h-auto rounded-lg"
              style={{ maxHeight: '280px', minHeight: '200px' }}
            />
          )}
        </div>
        {message && (
          <p className="mt-4 text-sm font-semibold text-gray-900 dark:text-white animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};